// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"787":"0fb8d680","811":"cc86177c"}[chunkId] + ".css";
};